export default class CurrentBalance{
    constructor({ currentBalance, messagePrice, imagePrice }){
        this.currentBalance = currentBalance;
        this.messagePrice = messagePrice;
        this.imagePrice = imagePrice;
    }

    render(container){
        container.innerHTML = '';

        const balanceInfoElement = document.createElement('div');
        balanceInfoElement.className = 'balance-section';

        const form = `
            <h2 class="section-title">
                <i class="fas fa-wallet"></i> Баланс и тарифы
            </h2>
            
            <div class="balance-info">
                <div class="balance-card gold">
                    <div class="balance-header">
                        <div class="balance-icon pulse-animation">
                            <i class="fas fa-coins"></i>
                        </div>
                        <div>
                            <div class="balance-title">Ваш баланс</div>
                            <div class="balance-value">${this.currentBalance} токенов</div>
                            <!-- <div class="balance-subtext">≈ 120 рублей</div> -->
                        </div>
                    </div>
                </div>
                
                <div class="balance-card">
                    <div class="balance-header balance-header-price">
                        <div>
                            <div class="balance-title">Цена сообщения</div>
                            <div class="balance-value blue">${this.messagePrice} токен</div>
                        </div>
                        <div>
                            <div class="balance-title">Генерация изображения</div>
                            <div class="balance-value green">${this.imagePrice} токенов</div>
                        </div>
                    </div>
                </div>
            </div>
        `

        balanceInfoElement.innerHTML = form;
        // balanceInfoElement.appendChild(price);
        container.appendChild(balanceInfoElement);
    }
}